export default __webpack_public_path__ + "static/media/manPressingPhone.b4790ae3.jpg";